import React, { useState } from "react";
import { DatePicker, Select } from "antd";
import { disableFutureDates } from "../../../services/util";
import timeZone from "../../../services/timezone.json";
import moment from "moment";
import { getDateTimeRangeOptions } from "../../Nexus/constant";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DateTimeRangePicker = ({ selectedDates, setSelectedDates, selectedTimeZone, setSelectedTimeZone }) => {
    const [isOpen, setIsOpen] = useState(false);
    function handleDateChange(e) {
        let start_date =
            e !== null ? moment(e[0]) : selectedDates[0];
        let end_date =
            e !== null ? moment(e[1]) : selectedDates[1];
        setSelectedDates([start_date, end_date]);
        setIsOpen(false);
    }

    // function showTimeZone() {
    //     return (
    //         <>
    //             Timezone :
    //             <Select showSearch onChange={(e) => setSelectedTimeZone(e)} style={{width: 350}} defaultValue={selectedTimeZone}>
    //                 {timeZone.map((tz) => (
    //                     <Option key={tz.value} value={tz.value}>
    //                         {tz.text}
    //                     </Option>
    //                 ))}
    //             </Select>
    //         </>
    //     );
    // }

    // function handleCalendarChange(dates) {
    //     if (isOpen) {
    //         setIsOpen(false);
    //       }
    // }

    return (
        <RangePicker
            // open={isOpen}
            // onFocus={() => setIsOpen(true)}
            // onOk={() => setIsOpen(false)}
            showTime={{
                format: "hh:mm A",
                use12Hours: true,
                onAmPmChange: () => {},
            }}
            allowClear={false}
            disabledDate={disableFutureDates}
            defaultValue={[moment(selectedDates[0]), moment(selectedDates[1])]}
            value={[moment(selectedDates[0]), moment(selectedDates[1])]}
            className="dashboard-date-search margin-right-5 select-container"
            onChange={handleDateChange}
            // onCalendarChange={handleCalendarChange}
            format="YYYY/MM/DD hh:mm A"
            ranges={getDateTimeRangeOptions()}
            // renderExtraFooter={() => showTimeZone()}
            style={{width: 350}}
        />
    );
};

export default DateTimeRangePicker;
